/* ============================================================
   Cart JS (cart-main.liquid) – quantity update & remove
   ============================================================ */
(function () {
  'use strict';

  function updateCartItem(key, qty) {
    fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(() => location.reload());
  }

  qsa('.js-cart-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const key   = btn.dataset.key;
      const input = qs(`input.js-cart-qty[data-key="${key}"]`);
      if (input) updateCartItem(key, Math.max(0, +input.value - 1));
    });
  });
  qsa('.js-cart-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const key   = btn.dataset.key;
      const input = qs(`input.js-cart-qty[data-key="${key}"]`);
      if (input) updateCartItem(key, +input.value + 1);
    });
  });
})();
